import gql from 'graphql-tag';
import { UserFragment } from '../fragments/user.fragment';
import { TagFragment } from '../fragments/tag.fragment';

export const REMOVE_TAG_USER = gql`
    mutation(
        $input: RelationsInput!
    ) {
        removeTagsFromUser (input: $input) {
            ...UserInfo
            tags{
                edges {
                    node {
                        ...TagInfo
                    }
                }
            }
        }
    }
    ${UserFragment}
    ${TagFragment}
`;